import React, { useContext } from "react";
import { Line } from "react-chartjs-2";
import { ThemeContext } from "../../../context/ThemeContext";
const BrriLineChart = ({ title, chartData }) => {
  const theme = useContext(ThemeContext);
  const labelColor = theme === "lite" ? "black" : "white"; // Evaluate the theme

  const data = {
    // labels: ["January", "February", "March", "April", "May", "June", "July"],
    labels: chartData?.label,
    datasets: [
      {
        label: title,
        // data: [65, 59, 80, 81, 56, 55, 40], // Sample data points
        data: chartData?.value, // Sample data points
        fill: false,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };

  // const options = {
  //   scales: {
  //     y: {
  //       beginAtZero: true,
  //     },
  //   },
  // };
  const options = {
    // maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: labelColor, // Change legend label color
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: labelColor, // Change X-axis label color
        },
        // title: {
        //   display: true,
        //   text: "Dates",
        //   color: labelColor, // Change X-axis title color
        // },
      },
      y: {
        beginAtZero: false,
        ticks: {
          color: labelColor, // Change Y-axis label color
        },
        // title: {
        //   display: true,
        //   text: "Value",
        //   color: labelColor, // Change Y-axis title color
        // },
      },
    },
  };

  return (
    <div>
      <Line data={data} options={options} />
    </div>
  );
};

export default BrriLineChart;
